export default __webpack_public_path__ + "static/media/projet-docker.8cf60895.png";